module.exports = __webpack_public_path__ + "static/media/BG_25.eed9ea05.png";